export default "__VITE_ASSET__BYNB6cAz__"